module.exports = __webpack_public_path__ + "img/policydoc.004f68c0.png";